import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateDataSearchTaiKhoanBank } from "../../../actions/TichHopBank/DanhSachTaiKhoanBank";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { DanhSachBankConst } from "../../../constants/danhSachTaiSanConst";

export const SearchBarDesktop = ({ onSearch }) => {
  const dispatch = useDispatch();

  const dataSearch = useSelector((state) => state.dataSearchTaiKhoanBank);

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const updateState = (field, text) => {
    dispatch(
      updateDataSearchTaiKhoanBank({
        ...dataSearch,
        [field]: text,
      })
    );
  };

  const [dataBankCombo, setDataBankCombo] = useState(DanhSachBankConst.Bank);
  useEffect(() => {


  }, []);
  return (
    <>
      <div className="search-new hidden-mobile-main show-table-main" style={{marginTop:10}}>
        <div className="input-sm-new input-new-18">
        
          <input
            placeholder="Tên cấp duyệt "
            type="text"
            className="form-control input-sm"
            value={dataSearch.tieude}
            onChange={updateTextValue("tieude")}
          ></input>
        </div>   
       
          <div className="input-sm-new input-new-18">
          <button type="submit" className="btn btn-info-new" onClick={onSearch}>
            <i className="la la-search"></i>
            <span> &nbsp; Tìm kiếm</span>
          </button>
        </div>
      </div>
    </>
  );
};
